import styled from 'styled-components';
import { Common } from '@stockbit/ui';

const { Flex, Modal } = Common;

export const Container = styled.div`
  height: 100%;
  overflow-y: hidden;

  #movers-wrapper {
    height: 100%;
    overflow: auto;

    #movers-table-wrapper {
      th {
        font-weight: 400;
      }
    }

    #movers-tab-menu-container {
      padding-left: 8px;
    }

    #movers-burger-menu {
      width: auto;
      > div {
        padding-right: 16px;
        padding-left: 16px;
      }
    }
  }
`;

export const HeaderContainer = styled(Flex).attrs({
  align: 'center',
  justify: 'space-between',
  px: '10px',
})`
  position: relative;
  background: #F2F4F5;
  height: 40px;
  border-bottom: 1px solid #D7D7D7;
`;

export const ButtonExpand = styled.div`
  cursor: pointer;
`;

export const ModalContentContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  border-radius: 0 0 8px 8px;

  #movers-table-wrapper {
    #movers-tab-menu-container {
      padding-left: 20px;
      padding-right: 20px;

      #movers-tab-menu-list-container {
        justify-content: space-between;
        padding-right: 88px;
      }

      #movers-burger-menu {
        right: 20px;
      }
    }

    tr {
      th {
        font-weight: 400;
      }

      > td:nth-child(1) {
        padding-left: 16px;
      }

      > td:last-child {
        padding-right: 16px;
      }
    }
  }
`;

export const ModalMovers = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;

    .ant-modal-header {
      border-radius: 8px 8px 0 0;
    }

    .ant-modal-body {
      border-radius: 0 0 8px 8px;
    }
  }
`;
